import axios from 'axios';
import { API_BASE_URL, API_URL } from '../../utils/constants';

export const handleInviteOperator = async ({
  position,
  fullName,
  email,
  mobile,
  password,
  accessLevel,
  selectedWebsiteIds,
}) => {
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/agent',
    withCredentials: true,
    data: JSON.stringify({
      title: position,
      name: fullName,
      email,
      tel: mobile,
      password,
      assignedChannels:
        selectedWebsiteIds == '' ? [] : selectedWebsiteIds.split(','),
      isAdmin: accessLevel === 'admin' ? true : false,
      newUserPhoto: '/images/avatar-agent-default.svg',
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchOperators = async () => {
  // axios.defaults.withCredentials = true;
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/agent/?includeStatics=${true}`,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchOperatorsBetweenDates = async (
  start_date,
  end_date
) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/agent/?includeStatics=${true}`,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      from: start_date,
      to: end_date,
    },
  });
  return response.data;
};

export const handleEditOperatorProfile = async ({
  operatorId,
  values,
  selectedAccessLevel,
  selectedWebsiteIds,
  imageUrl,
}) => {
  const payload = {
    id: operatorId,
    name: values.fullName,
    title: values.position,
    email: values.email,
    tel: values.mobile,
    password: values.password,
    assignedChannels:
      selectedWebsiteIds == '' ? [] : selectedWebsiteIds.split(','),
    isAdmin: selectedAccessLevel === 'admin' ? true : false,
  };

  if (imageUrl) {
    payload.newUserPhoto = imageUrl;
  } else {
    payload.newUserPhoto = '/images/avatar-agent-default.svg';
  }
  const response = await axios({
    method: 'put',
    baseURL: API_BASE_URL,
    url: `/agent/${operatorId}`,
    data: JSON.stringify(payload),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleEditOperatorMobile = async ({ mobile, operatorId }) => {
  const response = await axios({
    method: 'put',
    baseURL: API_BASE_URL,
    url: `/agent/${operatorId}`,
    data: JSON.stringify({ tel: mobile }),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleRemoveOperator = async (operatorId) => {
  const response = await axios({
    method: 'delete',
    baseURL: API_BASE_URL,
    url: `/agent/${operatorId}`,
    withCredentials: true,
  });
  return response.data;
};

export const handleUploadAvatar = async (uploadedImage, operatorId) => {
  const bodyFormData = new FormData();
  bodyFormData.append('avatar', uploadedImage);
  const response = await axios({
    method: 'post',
    baseURL: API_URL,
    url: '/v1/Upload/uploadAvatar',
    data: bodyFormData,
    withCredentials: false,
    params: {
      userId: operatorId,
    },
  });
  return response.data;
};

export const handleFetchOperatorReports = async (
  operator_id,
  startDtae,
  endDate
) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/agent/statistic',
    withCredentials: true,
    params: {
      agentId: operator_id,
      start: startDtae,
      end: endDate,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchSortedOperatorsList = async (start_date, end_date) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/agent/all`,
    withCredentials: true,
    params: {
      start: start_date,
      end: end_date,
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};
